import * as React from "react";

import { useQrCodeReader } from "./hooks/useQrCodeReader";

export const QrCodeReader = ({
  videoContainerStyle,
  containerStyle,
  videoStyle,
  ViewFinder,
  scanDelay = 500,
  className,
  onResult,
  streamRef,
}) => {
  const videoRef = React.useRef(null);

  useQrCodeReader({
    streamRef,
    scanDelay,
    onResult,
    videoRef,
  });

  return (
    <section className={className} style={containerStyle}>
      <div
        style={{
          ...{
            width: "100%",
            paddingTop: "100%",
            overflow: "hidden",
            position: "relative",
          },
          ...videoContainerStyle,
        }}
      >
        {!!ViewFinder && <ViewFinder />}
        <video
          muted
          ref={videoRef}
          style={{
            ...{
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "block",
              overflow: "hidden",
              position: "absolute",
              transform: undefined,
            },
            ...videoStyle,
          }}
        />
      </div>
    </section>
  );
};
